export default "__VITE_ASSET__CHtotRu8__"